import { connect } from 'react-redux'
// import MainComponent from '../components/MainComponent.jsx';
import MainComponent from '../components/MainComponentLte.jsx';
import {
	findAuthRoles,
	forwardToFindCategories,
	switchFunctionCategory,
	forwardToToggleMenu,
} from '../actions';

const mapStateToProps = (state) => ({
	roles: state.getIn(['authReducer', 'roles']),
	category: state.getIn(['menuReducer', 'category']),
	menu: state.getIn(['menuReducer', 'menu']),
	banner: state.getIn(['menuReducer',  'menu', 'banner']),
})

const mapDispatchToProps = (dispatch) => ({
	forwardToSwitchFunctionCategory: (category) => {
		dispatch(switchFunctionCategory(category));
	},

	findAuthRoles: () => {
		dispatch(findAuthRoles());
	},

	findCheckCategories: () => {
		dispatch(forwardToFindCategories());
	},

	toggleMenu: ()=>{
		dispatch(forwardToToggleMenu());
	},
})

const MainContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MainComponent)

export default MainContainer;


// WEBPACK FOOTER //
// ./src/containers/MainContainer.jsx